import { Button } from '@strata/react-buttons';
import { Form, Formik } from 'formik';

import { CapturedDataListener } from 'components/intakeForm/CapturedDataListener';
import { type IntakeFormSectionProps } from 'components/intakeForm/IntakeFormSectionProps';
import { PatientInputs } from 'components/intakeForm/PatientInputs';
import { useAppDispatch, useAppSelector } from 'store';
import { FormSections, IntakeFormSectionSchemas } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';
import { goToNextSection } from 'store/intakeForm/intakeFormThunks';

const Section = FormSections.PATIENT;

export const Patient = ({ isOpen }: IntakeFormSectionProps) => {
    const dispatch = useAppDispatch();
    const { capturedData } = useAppSelector((state) => state.intakeForm);

    return (
        <Formik
            initialValues={capturedData[Section]}
            enableReinitialize
            validateOnMount
            validationSchema={IntakeFormSectionSchemas[Section]}
            onSubmit={(values) => {
                dispatch(updateCapturedData({ [Section]: values }));
                dispatch(goToNextSection(Section));
            }}
        >
            {(formik) => (
                <Form className="sds_intake-form-section">
                    <CapturedDataListener section={Section} isOpen={isOpen} />
                    <PatientInputs />
                    <Button
                        intent={Button.Intent.PRIMARY}
                        id="patient-continue-button"
                        label="Continue"
                        type="submit"
                        disabled={!formik.isValid}
                    />
                </Form>
            )}
        </Formik>
    );
};
